<template>
  <div>
    <Breadcrumbs
      :paths="[]"
    ></Breadcrumbs>
    <v-container fluid>
      <v-row :class="(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'flex-column-reverse': ''">
        <v-col cols="12" md="4" lg="4" xl="4" class="pt-0" :class="(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? '' :'pr-0'">
          <LinkButton />
        </v-col>
        <v-col cols="12" md="8" lg="8" xl="8" :class="(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'pr-3 pb-8': 'pl-8'">
          <News />
          <template v-if="user && !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)">
            <RecentlyJob />
          </template>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '../components/Breadcrumbs'
import News from '../components/News'
import Navigation from '../components/Navigation'
import LinkButton from '../components/LinkButton'
import RecentlyJob from '../components/RecentlyJob'

export default {
  name: 'home',
  components: {
    Breadcrumbs,
    News,
    LinkButton,
    RecentlyJob,
    Navigation
  },
  computed: {
    ...mapGetters([
      'user',
    ]),
  },
  props:{
    side_menu: Boolean
  },
  data: function(){
    return {
      module_id: "02",
    }
  },
}
</script>
